import { z } from './utils/zod.js';
import { listResponse } from './utils/response-templates.js';
export const paymentSetupIntentResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({
        clientSecret: z.string(),
    }),
});
export const paymentMethodResponseSchema = z.object({
    id: z.string(),
    cardBrand: z.string(),
    cardLast4: z.string(),
    expiryMonth: z.number(),
    expiryYear: z.number(),
    isDefault: z.boolean(),
});
export const paymentMethodsResponseSchema = listResponse(paymentMethodResponseSchema);
export const setDefaultPaymentMethodRequestSchema = z.object({
    paymentMethodId: z.string().min(1),
    withdrawalConsent: z.literal(true).optional(),
});
export const setDefaultPaymentMethodResponseSchema = z.object({
    success: z.boolean(),
});
